module.exports = __webpack_public_path__ + "img/dom.99446df9.svg";